<template>
  <p>
    Please contact us if you have any questions or would like more information!<br/><br/>
    Phone: <a href="tel:+1-951-375-7579">+1-951-375-7579</a><br/>
    Email: <a href="mailto:service@europrecastconcrete.com">service@europrecastconcrete.com</a><br/>
    <a href="https://www.facebook.com/europrecastconcrete/">Facebook page</a><br/>
  </p>
</template>

<script>
  export default {
    name: "Contact"
  }
</script>

<style scoped>

</style>